export enum MediaShape {
  Circle = 'circle',
  Square = 'square',
  Rectangle = 'rectangle',
  Banner = 'banner',
  Contentbanner = 'contentbanner',
  Logo = 'logo',
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export enum MediaTypes {
  IMAGE = 'image,recimage',
  VIDEO = 'video,recvideo',
  MEDIA = 'image,recimage,video,recvideo',
  LOGO = 'logo',
  JOB_PAGE_ICON = 'jobpageicons',
}

export enum PageTypes {
  NEW = 'new',
  DUPLICATE = 'duplicate',
  USE_AS_TEMPLATE = 'use_as_template',
}
